import { render, staticRenderFns } from "./RequestRgDetail.vue?vue&type=template&id=54a95502&scoped=true"
import script from "./RequestRgDetail.vue?vue&type=script&lang=js"
export * from "./RequestRgDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a95502",
  null
  
)

export default component.exports